import { Pipe, PipeTransform } from '@angular/core';
import { College } from '../classes/College/CollegeEnum';

@Pipe({
    name: 'collegeSchoolYear'
})
export class CollegeSchoolYearPipe implements PipeTransform {
    transform(year : string, collegeID?: number) {
        if (!year) return '';

        let cyear = parseInt(year, 10);

        if (collegeID == null) {
            return '20' + year.substr(0, 2) + ' - 20' + year.substr(2);
        }

        switch(collegeID) {
            case College.PolkStateCollege:
                // Polk State College years are 1 year ahead of Polk County Public Schools, so subtract one when displaying.
                return ((cyear - 1) + ' - ' + cyear);
            case College.SoutheasternUniversity:
            default:
                return (cyear + ' - ' + (cyear + 1));
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/collegeschoolyear.pipe.ts